export * as SocialMediaSwaggerTypes from './swagger/socialMedia/types';
export var SnsMarketingMediaType;
(function (SnsMarketingMediaType) {
    SnsMarketingMediaType["AUDIO"] = "AUDIO";
    SnsMarketingMediaType["IMAGE"] = "IMAGE";
    SnsMarketingMediaType["VIDEO"] = "VIDEO";
    SnsMarketingMediaType["FILE"] = "FILE";
    SnsMarketingMediaType["GIF"] = "GIF";
})(SnsMarketingMediaType || (SnsMarketingMediaType = {}));
export var SnsMarketingPlatform;
(function (SnsMarketingPlatform) {
    SnsMarketingPlatform["FACEBOOK"] = "FACEBOOK";
    SnsMarketingPlatform["LINKEDIN"] = "LINKEDIN";
    SnsMarketingPlatform["INSTAGRAM"] = "INSTAGRAM";
})(SnsMarketingPlatform || (SnsMarketingPlatform = {}));
export const SnsPlatformName = {
    [SnsMarketingPlatform.FACEBOOK]: 'Facebook',
    [SnsMarketingPlatform.LINKEDIN]: 'LinkedIn',
    [SnsMarketingPlatform.INSTAGRAM]: 'Instagram',
};
export var SnsMarketingAccountType;
(function (SnsMarketingAccountType) {
    SnsMarketingAccountType["PERSONAL"] = "PERSONAL";
    SnsMarketingAccountType["PAGE"] = "PAGE";
})(SnsMarketingAccountType || (SnsMarketingAccountType = {}));
export var SnsMarketingAuthorizeType;
(function (SnsMarketingAuthorizeType) {
    SnsMarketingAuthorizeType["PRIVATE"] = "PRIVATE";
    SnsMarketingAuthorizeType["ALLOCATION"] = "ALLOCATION";
})(SnsMarketingAuthorizeType || (SnsMarketingAuthorizeType = {}));
export var SnsPostType;
(function (SnsPostType) {
    SnsPostType["COMPANY_INFO"] = "COMPANY_INFO";
    SnsPostType["PRODUCT_INFO"] = "PRODUCT_INFO";
    SnsPostType["INDUSTRY"] = "INDUSTRY";
    SnsPostType["CUSTOM"] = "CUSTOM";
})(SnsPostType || (SnsPostType = {}));
export const getSnsPostTypeName = () => {
    return {
        [SnsPostType.COMPANY_INFO]: '公司介绍',
        [SnsPostType.PRODUCT_INFO]: '商品介绍',
        [SnsPostType.INDUSTRY]: '行业资讯',
        [SnsPostType.CUSTOM]: '自定义',
    };
};
export var SnsPostCreateType;
(function (SnsPostCreateType) {
    SnsPostCreateType["AI_TASK"] = "AI_TASK";
    SnsPostCreateType["AI_INSTANT"] = "AI_INSTANT";
    SnsPostCreateType["AI_CRON"] = "AI_CRON";
    SnsPostCreateType["MANUAL_INSTANT"] = "MANUAL_INSTANT";
    SnsPostCreateType["MANUAL_CRON"] = "MANUAL_CRON";
})(SnsPostCreateType || (SnsPostCreateType = {}));
export var SnsMarketingAiPicStyle;
(function (SnsMarketingAiPicStyle) {
    SnsMarketingAiPicStyle["commerce"] = "commerce";
    SnsMarketingAiPicStyle["fresh"] = "fresh";
    SnsMarketingAiPicStyle["warm"] = "warm";
})(SnsMarketingAiPicStyle || (SnsMarketingAiPicStyle = {}));
export const getSnsMarketingAiPicStyleName = () => {
    return {
        commerce: '商务风',
        fresh: '清新风',
        warm: '亲和风',
    };
};
export var SnsAccountAuthorizedStatus;
(function (SnsAccountAuthorizedStatus) {
    SnsAccountAuthorizedStatus["AUTHORIZED"] = "AUTHORIZED";
    SnsAccountAuthorizedStatus["EXPIRES"] = "EXPIRES";
})(SnsAccountAuthorizedStatus || (SnsAccountAuthorizedStatus = {}));
export const getSnsAccountAuthorizedStatusName = () => {
    return {
        AUTHORIZED: '已授权',
        EXPIRES: '授权失效',
    };
};
export var SnsAccountBindingStatus;
(function (SnsAccountBindingStatus) {
    SnsAccountBindingStatus["NO_OPERATE"] = "NO_OPERATE";
    SnsAccountBindingStatus["BIND_SUCCESS"] = "BIND_SUCCESS";
    SnsAccountBindingStatus["BIND_FAILED"] = "BIND_FAILED";
    SnsAccountBindingStatus["NO_ALL_PERMISSIONS"] = "NO_ALL_PERMISSIONS";
    SnsAccountBindingStatus["REPEAT_BIND"] = "REPEAT_BIND";
    SnsAccountBindingStatus["USER_CANCEL"] = "USER_CANCEL";
})(SnsAccountBindingStatus || (SnsAccountBindingStatus = {}));
export const getSnsAccountBindingStatusName = () => {
    return {
        NO_OPERATE: '用户未操作绑定',
        BIND_SUCCESS: '绑定成功',
        BIND_FAILED: '绑定失败',
        NO_ALL_PERMISSIONS: '没有勾选全部权限',
        REPEAT_BIND: '社媒账号已经被其他外贸通账户绑定',
        USER_CANCEL: '用户取消绑定',
    };
};
export var SnsTaskStatus;
(function (SnsTaskStatus) {
    SnsTaskStatus["DRAFT"] = "DRAFT";
    SnsTaskStatus["GENERATING"] = "GENERATING";
    SnsTaskStatus["FINISH_GENERATE"] = "FINISH_GENERATE";
    SnsTaskStatus["START"] = "START";
    SnsTaskStatus["RUNNING"] = "RUNNING";
    SnsTaskStatus["PAUSE"] = "PAUSE";
    SnsTaskStatus["FINISH"] = "FINISH";
})(SnsTaskStatus || (SnsTaskStatus = {}));
export const PostCreateTypeOptions = [
    {
        label: '营销任务',
        value: SnsPostCreateType.AI_TASK,
    },
    {
        label: '手动发帖',
        value: [SnsPostCreateType.AI_INSTANT, SnsPostCreateType.AI_CRON, SnsPostCreateType.MANUAL_INSTANT, SnsPostCreateType.MANUAL_CRON].join(','),
    },
];
export const SnsTaskStatusOptions = [
    {
        value: SnsTaskStatus.DRAFT,
        label: '草稿',
    },
    {
        value: SnsTaskStatus.GENERATING,
        label: '帖子生成中',
    },
    {
        value: SnsTaskStatus.FINISH_GENERATE,
        label: '帖子生成完成',
    },
    {
        value: SnsTaskStatus.RUNNING + ',' + SnsTaskStatus.START,
        label: '进行中',
    },
    {
        value: SnsTaskStatus.PAUSE,
        label: '已暂停',
    },
    {
        value: SnsTaskStatus.FINISH,
        label: '已完成',
    },
];
export var SnsPostStatus;
(function (SnsPostStatus) {
    SnsPostStatus["GENERATING"] = "GENERATING";
    SnsPostStatus["FINISH_GENERATE"] = "FINISH_GENERATE";
    SnsPostStatus["FAILED_GENERATE"] = "FAILED_GENERATE";
    SnsPostStatus["WAITING"] = "WAITING";
    SnsPostStatus["PENDING"] = "PENDING";
    SnsPostStatus["SUCCEED"] = "SUCCEED";
    SnsPostStatus["FAILED"] = "FAILED";
    SnsPostStatus["PAUSE"] = "PAUSE";
    SnsPostStatus["EXPIRES"] = "EXPIRES";
    SnsPostStatus["DELETED"] = "DELETED";
})(SnsPostStatus || (SnsPostStatus = {}));
export const getSnsPostStatusName = () => {
    return {
        [SnsPostStatus.GENERATING]: 'AI生成中',
        [SnsPostStatus.FINISH_GENERATE]: 'AI生成完成',
        [SnsPostStatus.FAILED_GENERATE]: 'AI生成失败',
        [SnsPostStatus.WAITING]: '待发送',
        [SnsPostStatus.PENDING]: '发送中',
        [SnsPostStatus.SUCCEED]: '发送成功',
        [SnsPostStatus.FAILED]: '发送失败',
        [SnsPostStatus.PAUSE]: '暂停发送',
        [SnsPostStatus.EXPIRES]: '已过期',
        [SnsPostStatus.DELETED]: '已删除',
    };
};
export var SnsMarketingMessageDirection;
(function (SnsMarketingMessageDirection) {
    SnsMarketingMessageDirection["OUT"] = "OUT";
    SnsMarketingMessageDirection["IN"] = "IN";
})(SnsMarketingMessageDirection || (SnsMarketingMessageDirection = {}));
export var OperationTaskNodeStatusEnum;
(function (OperationTaskNodeStatusEnum) {
    OperationTaskNodeStatusEnum["NOT_START"] = "NOT_START";
    OperationTaskNodeStatusEnum["PENDING"] = "PENDING";
    OperationTaskNodeStatusEnum["FINISH"] = "FINISH";
})(OperationTaskNodeStatusEnum || (OperationTaskNodeStatusEnum = {}));
export var OperationTaskStatusEnum;
(function (OperationTaskStatusEnum) {
    OperationTaskStatusEnum["START"] = "START";
    OperationTaskStatusEnum["PAUSE"] = "PAUSE";
})(OperationTaskStatusEnum || (OperationTaskStatusEnum = {}));
